import Divider from '@material-ui/core/Divider';
import React from 'react';

const VerticalBoxDivider: React.FunctionComponent = () => {
  return <Divider orientation="vertical" flexItem />;
};

export { VerticalBoxDivider };
